import SignaturePad from "signature_pad";

window.SignaturePad = SignaturePad;

function resizeCanvas($canvas) {
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  // $canvas[0].width = $canvas[0].offsetWidth * ratio;
  // $canvas[0].height = $canvas[0].offsetHeight * ratio;
  $canvas[0].getContext("2d").scale(ratio, ratio);
  $canvas.data('signaturePad').clear(); // otherwise isEmpty() might return incorrect value
}

function setupCanvas($canvas) {
  // Get the device pixel ratio, falling back to 1.
  const dpr = window.devicePixelRatio || 1;

  // Get the size of the canvas in CSS pixels.
  const rect = $canvas[0].getBoundingClientRect();

  // Give the canvas pixel dimensions of their CSS
  // size * the device pixel ratio.
  $canvas[0].width = rect.width * dpr;
  $canvas[0].height = rect.height * dpr;
  const ctx = $canvas[0].getContext('2d');

  // Scale all drawing operations by the dpr, so you
  // don't have to worry about the difference.
  ctx.scale(dpr, dpr);

  return ctx;
}

export const initSignaturePads = () => {
  $('canvas.signature').each(function () {
    const $canvas = $(this);

    // Set the canvas width to the available space.
    // $canvas.attr('width', parseInt($canvas.parent().innerWidth()));

    // Create the SignaturePad object.
    $canvas.data('signaturePad', new SignaturePad($canvas[0], {
      minWidth: 0.1,
      maxWidth: 1,
      dotSize: 1,
    }));

    // Bind to an input for form saving.
    if ($canvas.data('input') !== undefined) {
      $canvas.data('signaturePad').addEventListener("endStroke", () => {
        $(`input[name=${$canvas.data('input')}]`).val($canvas.data('signaturePad').toDataURL());

        $(`input[name=${$canvas.data('input')}]`)[0].dispatchEvent(new Event('input'));
      });
    }

    // DPI fix.
    setupCanvas($canvas);

    // Load any data that was previously saved.
    if ($canvas.data('load') !== undefined) {
      loadSignaturePadData($canvas, $canvas.data('load'));
    }

    // Bind the clear button.
    $canvas.parent().find('[data-clear-signature]').on('click', function () {
      $canvas.data('signaturePad').clear();
    });
  });

  // $(window).on('resize', function () {
  //     window.requestAnimationFrame(function () {
  //         $('canvas.signature').each(function () {
  //             resizeCanvas($(this));
  //         });
  //     });
  // });

  // Trim canvases on form submission.
  // $('form').on('submit', function () {
  //     $('canvas.signature').each(function () {
  //         trimCanvas($(this)[0]);
  //     });
  // });
};

// Draws signature image from an array of point groups
export const loadSignaturePadData = ($canvas, data) => {
  $canvas.data('signaturePad').fromDataURL(data);

  // Do we need to load the data into the input?
  if ($canvas.data('input') !== undefined) {
    setTimeout(() => {
      $(`input[name=${$canvas.data('input')}]`).val($canvas.data('signaturePad').toDataURL());
    }, 150);
  }

  return true;
};

document.addEventListener("livewire:init", () => {
  Livewire.hook('commit', ({ succeed }) => {
    succeed(() => {
      queueMicrotask(() => initSignaturePads());
    });
  });
});

document.addEventListener("signatureVisibilityChange", () => {
    initSignaturePads();
});
